module.exports = __webpack_public_path__ + "img/4.c7b3da59.jpg";